<template>
  <div class="card-container">
    <template v-if="cardList && cardList.length > 0">
      <div class="card" v-for="item in cardList">
        <img v-if="item.vipType == 1" src="@/../static/m1.png" class="card-img" />
        <img v-else-if="item.vipType == 2" src="@/../static/m2.png" class="card-img" />
        <img v-else-if="item.vipType == 3" src="@/../static/m3.png" class="card-img" />

        <div class="info-box">
          <div class="name">{{item.username}}</div>
          <div class="no">NO.{{formatNumber(item.memberId)}}</div>
          <div class="valid" v-if="formatDate(item.startTime) <= 0">已过期</div>
          <div class="valid" v-else>有效期剩余{{formatDate(item.startTime)}}天</div>
        </div>
      </div>
    </template>
    <div v-else-if="showError">
      没有您的会员卡信息
    </div>
    <div class="intent-block urge-block" v-else>
      <div class="intent-title">
        <span><img src="@/../static/title_left.png"></span>
        会员卡
        <span><img src="@/../static/title_right.png"></span>
      </div>

      <div class="control-block row">
        <div class="control-label">
          证件类型：
        </div>
        <div class="control-input">
          <select class="form-control" v-model="loginForm.cardType">
            <option v-for="(cardType, i) in cardTypes" :value="i" :key="i">{{cardType}}</option>
          </select>
        </div>
      </div>

      <div class="control-block row">
        <div class="control-label">
          证件号码：
        </div>
        <div class="control-input">
          <input type="text"
            v-validate="{'required':true, 'idcard':(loginForm.cardType==0), 'passportcard':(loginForm.cardType==1), 'hkcard':(loginForm.cardType==2), 'twcard':(loginForm.cardType==3)}"
            class="form-control" name="idcard" placeholder="请输入证件号码" v-model="loginForm.idNumber" />
          <span v-show="errors.has('idcard')" class="error-text">{{errors.first('idcard')}}</span>
        </div>
      </div>



      <van-loading v-if="isLoading" size="20">查询中...</van-loading>
      <div class="control-block row button-block">
        <button type="button" :disabled="isLoading" class="button button-primary" @click="handleLogin">查询</button>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    MessageBox,
    Toast
  } from "mint-ui"
  import wx from "weixin-js-sdk"
  import moment from 'moment'

  export default {
    components: {},
    data() {
      return {
        isLoading: false,
        wechatSign: {},
        openId: "",
        code: "",
        uuid: "",
        cardList: [],
        showError: false,
        cardTypes: ["身份证", "护照", /*"驾驶证",*/ "港澳居民通行证", "台胞证"],
        loginForm: {
          idNumber: '',
          cardType: 0
        }
      }
    },
    mounted() {
      document.title = "";
      if (this.$route.query.uuid) {
        this.uuid = this.$route.query.uuid;
      }


      let self = this;
      wx.ready(function(){
          console.log("wechat ready!")
          self.getOpenId();
      });
      wx.error(function(res){
          self.isLoading = false
          MessageBox.alert("微信支付初始化失败" +  JSON.stringify(res));
          self.addLog(JSON.stringify(res), "微信支付初始化")
      });

      this.getWechatSign();
    },

    methods: {
      formatNumber: function(num) {
        return String(num).padStart(7, '0')
      },
      formatDate: function(start) {
        const date = new Date()
        const endDate = new Date(start);
        endDate.setDate(endDate.getDate() + 365)

        date.setHours(0, 0, 0, 0);
        endDate.setHours(0, 0, 0, 0);


        const diffTime = endDate.getTime() - date.getTime();
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        return diffDays
      },
      getWechatSign: function() {
        const self = this;
        let url = location.href;
        if (url.indexOf('#') > 0) {
          url = url.substring(0, url.lastIndexOf('#'))
        }
        // url = location.protocol + "://" + location.hostname + location.pathname +
        // "?cityCode=" + self.$route.query.cityCode + "&type=" + self.$route.query.type;
        let encodeUrl = encodeURIComponent(url);
        this.$http.get("/bicycle/inter/getWechatSign?url=" + encodeUrl).then(function(res) {
          if (res.data.status != 200) {
            MessageBox.alert(res.data.errorMsg);
          } else {
            let e = res.data.data;

            if (self.$route.query.code) {
              self.code = self.$route.query.code;
              console.log(url)
              wx.config({
                debug: false, // 关闭调试模式
                appId: e.appId, // 必填，公众号的唯一标识
                timestamp: e.timestamp, // 必填，生成签名的时间戳
                nonceStr: e.nonceStr, // 必填，生成签名的随机串
                signature: e.signature, // 必填，签名
                jsApiList: ['chooseWXPay', 'updateAppMessageShareData', 'updateTimelineShareData',
                  'onMenuShareTimeline'
                ],
                openTagList: ['wx-open-subscribe', 'wx-open-launch-weapp']
              });
              //获取openId
              if (!self.openId) {
                self.wechatReady = true;
              } else {
                self.wechatReady = true;
              }
              // history.pushState({}, document.title, url);
            } else {
              let currentUrl = location.origin + location.pathname + "?uuid=" + self.uuid;
              let redirectUrl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + e.appId +
                "&redirect_uri=" + encodeURIComponent(currentUrl) +
                "&response_type=code&scope=snsapi_base&state=123#wechat_redirect";
              window.location.href = redirectUrl;
            }
          }
        }).catch(function(error) {
          console.log(error)
          MessageBox.alert("您的网络不太好，请刷新重试")
          self.addLog(JSON.stringify(error), "获取微信签名")
        });
      },

      getOpenId: function() {
        const self = this;
        this.isLoading = true;
        self.$http.get("/bicycle/inter/getOpenId?code=" + self.code).then(function(res) {
          self.isLoading = false
          if (res.data.status == 200) {
            //正常获取数据
            self.openId = res.data.data;
            localStorage.setItem("openId", self.openId);
            self.wechatReady = true;
            self.getMemberCard()


          } else if (res.data.status == 302) {
            //用户刷新页面导致Code过期
            let url = location.origin + location.pathname + "?uuid=" + self.uuid;
            window.location.href = url
          } else {
            self.wechatReady = false
            MessageBox.alert(res.data.errorMsg).then(action => {
              let url = location.origin + location.pathname + "?uuid=" + self.uuid;
              window.location.href = url
            });
          }
        }).catch(function(error) {
          console.log(error)
          self.isLoading = false
          MessageBox.alert('错误，获取微信信息失败。请重新打开页面').then(action => {
            let url = location.origin + location.pathname + "?uuid=" + self.uuid;
            window.location.href = url
          });
          self.addLog(JSON.stringify(error), "获取openId")
        });
      },
      getMemberCard: function() {
        const self = this
        self.$http.get("/bicycle/inter/memberCard?openId=" + this.openId + "&uuid=" + this.uuid).then(function(
          res) {
          if (res.data.status != 200) {
            MessageBox.alert(res.data.errorMsg);
          } else {
            self.cardList = res.data.data
          }
        }).catch(function(error) {
          MessageBox.alert("获取会员卡失败，网络错误");
        })
      },
      handleLogin: function() {
        const self = this
        const params = {
          idNumber: this.loginForm.idNumber,
          openId: this.openId
        }
        try {
          const self = this
          this.$validator.validate().then(valid => {
            if (valid) {
              self.isLoading = true

              self.$http.post("/bicycle/inter/getMemberCard", params).then(function(res) {
                self.isLoading = false
                if (res.data.status == 200) {
                  self.cardList = res.data.data
                  if (self.cardList.length == 0) {
                    self.showError = true
                  }
                }
              }).catch(function(err) {
                console.log(err)
                self.isLoading = false
              })
            }
          })
        } catch (err) {

        }

      }


    }
  }
</script>

<style scoped>
  .card-container {
    height: 100vh;
    width: 100vw;
    background: #fff;
    box-sizing: border-box;
    padding-top: 24px;
  }

  .card {
    display: flex;
    justify-content: center;
    position: relative;
  }

  .card-img {
    width: 93.33vw;
    position: absolute;
    z-index: 1;
  }

  .info-box {
    z-index: 2;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    height: 40vw;
    align-items: flex-end;
    box-sizing: border-box;
    padding: 3vw 8vw;
    position: relative;
  }
  .name{
    position: absolute;
    left: 8vw;
    top: 3vw;
    font-size: 20px;
    font-weight: bold;
    color: #324a4e;
    text-shadow: 0px 0px 0px #fff;
  }

  .no {
    color: #71737a;
    font-size: 12px;
  }

  .valid {
    color: #324a4e;
    font-size: 12px;
    text-shadow: 0px 0px 0px #324a4e;
  }

  .intent-title {
    text-align: center;
    color: rgb(19, 124, 215);
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 25px;
  }

  .control-block {
    margin-top: 11px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .control-label {
    color: rgb(102, 102, 102);
    font-size: 15px;
    float: left;
    width: 30%;
  }

  .control-input {
    width: 70%;
  }

  .form-control {
    border: 1px solid rgb(229, 229, 229);
    border-radius: 6px;
    height: 38px;
    color: rgb(51, 51, 51);
    font-size: 15px;
    padding: 0 14px;
    width: 100%;
    background: #fff;
  }

  .radio-inline {
    padding: 0 0;
    display: flex;
    align-items: center;
  }

  .radio-row {
    padding: 0 0;
    display: flex;
    flex-direction: column;
    height: auto;
    padding: 7px 0;
  }

  .radio-row label {
    margin-left: 14px;
    padding: 7px 0;
  }

  .radio-inline input {
    margin-left: 14px;
  }

  .add {
    justify-content: start;
    margin-top: 35px
  }

  input,
  select,
  textarea {
    box-sizing: border-box;
  }

  textarea {
    min-height: 60px;
  }

  .button-block {
    margin-top: 35px;
  }

  .button-add:active {
    opacity: 0.7;
  }

  .order-height {
    height: 74px;
  }

  .order-block {
    background-color: #FFF;
    height: 64px;
    box-shadow: 2px -2px 5px #ccc;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 12px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }


  .error-text {
    color: red;
    padding-left: 12px;
  }

  input::-webkit-input-placeholder,
  textarea::-webkit-input-placeholder {
    color: rgb(208, 208, 208);
    font-size: 15px;
  }

  input:-moz-placeholder,
  textarea:-moz-placeholder {
    color: rgb(208, 208, 208);
    font-size: 15px;
  }

  input::-moz-placeholder,
  textarea::-moz-placeholder {
    color: rgb(208, 208, 208);
    font-size: 15px;
  }

  input:-ms-input-placeholder,
  textarea:-ms-input-placeholder {
    color: rgb(208, 208, 208);
    font-size: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/MemberCard.vue